import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { onUnmounted, ref, Ref, onActivated, nextTick, onMounted } from 'vue'
import { usePiniaState } from "@/store/userPinia";
import EventBus from "@/uitls/EventBus";
import indexDB from "@/network/db/dexieDb";
import { imMessageListModel } from "@/model/chatModel";
import { md5, YMPush } from "@/uitls/uitls";
import { useRoute, useRouter } from "vue-router";
import { delImList, getIMListAll, getIMListItem, syncIMListRedWithUnread, updateIMList } from "@/network/db/dbServe"
import { msg_get_group_info } from "@/network/socket/SocketReq"
import MessageItem from "@/components/MessageItem.vue"
import Platform from "@/config/platform";
import { useI18n } from 'vue-i18n'
import { toDownloadApp } from '@/uitls/native';
import Storage from "@/uitls/Storage";

export default /*#__PURE__*/_defineComponent({
  name: 'Message',
  props: {
    jumpType: { type: Number, required: false },
    isGroup: { type: Number, required: false }
  },
  emits: ['endEditAction', 'tochat'],
  setup(__props: any, { expose, emit: emits }) {
  expose();

const props = __props as {
  //0=默认 1= 需要返回按钮 2=直播间嵌套
  jumpType?: number,
  //0=默认 1= 私聊 2=群聊
  isGroup?: number
}

_useCssVars(_ctx => ({
  "8d2d3196-listDivMarginTop": (listDivMarginTop.value)
}))

const { t } = useI18n()
const router = useRouter();
const route = useRoute();

let { type } = route.query;
const userStore = usePiniaState();
const { toLogin } = userStore;
const msgList = ref([]) as Ref<Array<imMessageListModel>>
const th = process.env.VUE_APP_Language as string;
//子调用父的方法



onMounted(() => {
  firstAction();
});

onActivated(() => {
  firstAction();
});

const firstAction = () =>{
  let { type } = route.query;
  type = type;
  toLogin();
  nextTick(() => {
    getMsgList();
  });
  
  YMPush('MAIN', 'ChatPage')

  let { webclip } = route.query;
  if (webclip) {
    isWebclip.value = true;
  } else {
    isWebclip.value = false;
  }
  getTop();
};

const isWebclip = ref(false)

const listDivMarginTop = ref('')

const getTop = () => {
  if(props.jumpType == 2){
    listDivMarginTop.value = '0px';
  }else{
    listDivMarginTop.value = type == '1' ? '60px' : '150px';
  }
}

const arterBg = require(`@/assets/${process.env.VUE_APP_NAME}/download.png`)
const arterBtn = require(`@/assets/${process.env.VUE_APP_NAME}/download_btn.png`)
const offArterBtn = require("@/assets/images/guanbi.png")

const badge = ref(0)
onUnmounted(() => {
  // EventBus.all.clear();
  EventBus.off("imlist")
  EventBus.off("dbOnsuccess")
});

EventBus.on("dbOnsuccess", () => {
  getMsgList();
});

EventBus.on("imlist", () => {
  getMsgList()
});
const getMsgList = async () => {
  nextTick(async () => {
    if (!indexDB.open) {
      return;
    }
    msgList.value = [];
    const v = await getIMListAll();
    const myUid = Storage.get('uid');
    await Promise.all(v.map(async (item: any) => {
      if (!item.chatkey) {
        return;
      }
      item.red = await syncIMListRedWithUnread(item.chatkey, myUid);
    }));
    v.sort((a: any, b: any) => {
      if (a.time < 100000000000) {
        a.time = a.time * 1000
      }
      if (b.time < 100000000000) {
        b.time = b.time * 1000
      }
      return b.time - a.time;
    })

    for (let i = 0; i < v.length; i++) {
      const element = v[i] as any;

      if (element.isGroup) {
        //生成群头像
        let nickname: string = element.nickname
        if (!!!nickname) msg_get_group_info(element.chatkey);
        if (nickname && nickname.length > 0) {
          nickname = nickname.substring(0, 4)
        } else {
          nickname = '群'
        }

        const regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
        const emjio = regex.exec(nickname);
        if (emjio) {
          //如果有emjio
          element.headurl = emjio[0];
        } else {
          element.headurl = nickname[0];
        }
        //生成颜色
        let bgcolor = "#" + md5(nickname[0])
        bgcolor = bgcolor.substring(0, 7)
        element.bgc = bgcolor
      }
    }
    msgList.value = [];
    let tempList = [];
    for (let i = 0; i < v.length; i++) {
      const item = v[i] as any;
      item.checked = false;
      if(props.isGroup == 1){
        //直播间私聊列表
        if(!item.isGroup){
          tempList.push(item);
        }
      }else if(props.isGroup == 2){
        //直播间群聊列表
         if(item.isGroup){
          tempList.push(item);
        }
      }else{
        //消息页面
         tempList.push(item);
      }
    }

    msgList.value = tempList;
    console.log('getMsgList', v);
  });
}

const toChat = (data) => {
  console.log(' go to chat:', data.chatkey);
  if(props.jumpType == 2){
    emits('tochat', data.chatkey);
  }else{
    router.push(`/chat/?id=${data.chatkey}`)
  }
}

const onClickLeft = () => {
  router.back();
}
const downloadshow = ref(false);
const showDownApp = () => {
  let { webclip } = route.query;
  if (!webclip) {
    downloadshow.value = true;
  }
};
const open = () => {
  if (Platform.downUrl != "") {
    YMPush("DOWNLOAD", "点击下载")
    toDownloadApp();
  }
};

const editPage = ref(false)

const editCheck = (chatkey) => {
  let allcheck1 = true;
  for (let i = 0; i < msgList.value.length; i++) {
    const item = msgList.value[i];
    if (item.chatkey == chatkey) {
      item.checked = !item.checked
    }
    if (!item.checked) {
      allcheck1 = false
    }
  }
  allCheck.value = allcheck1
}
//全选
const allCheck = ref(false)

const onAllcheck = () => {
  allCheck.value = !allCheck.value

  for (let i = 0; i < msgList.value.length; i++) {
    const item = msgList.value[i];

    item.checked = allCheck.value
  }

}

//标记为已读
const yidu = async () => {
  for (let i = 0; i < msgList.value.length; i++) {
    const item = msgList.value[i];
    if (item.checked) {
      const imItem: imMessageListModel = await getIMListItem(item.chatkey)
      imItem.red = 0;
      updateIMList(item.chatkey, imItem)
      item.red = 0;
    }
  }
  editPage.value = false;
}

const delMsg = async (data) => {
  const v = await delImList(data.chatkey)
  getMsgList()
}

//获取会话列表，获取数据库里面的

const __returned__ = { t, router, route, type, userStore, toLogin, msgList, th, emits, props, firstAction, isWebclip, listDivMarginTop, getTop, arterBg, arterBtn, offArterBtn, badge, getMsgList, toChat, onClickLeft, downloadshow, showDownApp, open, editPage, editCheck, allCheck, onAllcheck, yidu, delMsg, MessageItem }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})